<template>
    <div class="text-center text-lg" data-cy="text_notfound_message">
        Page not found
    </div>
</template>
<script>
export default {
    name: 'Notfound',
}
</script>
<style lang="scss" scoped>
</style>
